import type { StudioPreflightCheckCategory } from '~entities/studios/model/preflight-check.types';

export const PREFLIGHT_CHECK_ID = {
  TIMEZONE: 'timezone',
  EVENT_GHL_CALENDAR: 'event_ghl_calendar',
} as const;

export const PREFLIGHT_CHECK_STATUS = {
  PASS: 'pass',
  WARN: 'warn',
  FAIL: 'fail',
} as const;

export interface PreflightCheckCategoryProps {
  category: StudioPreflightCheckCategory;
}

export interface PreflightCheckItemProps {
  check: StudioPreflightCheckCategory['checks'][number];
}
